import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { Logger } from '@shared/common/logger';
import type { TBookAlias } from '@shared/jp/product';
import { BOOK_ALIAS_GIFT } from '@shared/common/product';
import { fbBookAliasArr } from 'src/app/data/books';

const log = new Logger('AliasSelectComponent');

@Component({
  selector: 'app-alias-select',
  templateUrl: './alias-select.component.html',
  styleUrls: ['./alias-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AliasSelectComponent {
  @Output() selected = new EventEmitter<TBookAlias[] | undefined>();

  public readonly BOOK_ALIAS_GIFT = BOOK_ALIAS_GIFT;

  public readonly aliasArr = fbBookAliasArr;

  public selectedAliasArr: TBookAlias[] = [];

  public isAll = true;

  // constructor() {}

  check(alias: TBookAlias) {
    if (alias === BOOK_ALIAS_GIFT) {
      return this.isAll;
    }

    return this.selectedAliasArr.includes(alias);
  }

  select(alias: TBookAlias) {
    if (alias === BOOK_ALIAS_GIFT) {
      this.isAll = true;

      this.selected.emit(undefined);

      return;
    }

    this._add(alias);
  }

  deselect(alias: TBookAlias) {
    if (alias === BOOK_ALIAS_GIFT) {
      this.isAll = false;

      this.selected.emit(this.selectedAliasArr);

      return;
    }

    this._remove(alias);
  }

  private _add(alias: TBookAlias) {
    if (this.check(alias)) {
      log.warn(`${alias} already in array`);
      return;
    }

    const arr = [...this.selectedAliasArr];

    arr.push(alias);

    this.selectedAliasArr = arr;
    this.selected.emit(this.selectedAliasArr);
  }

  private _remove(alias: TBookAlias) {
    const i = this.selectedAliasArr.indexOf(alias);

    if (i < 0) {
      log.warn(`${alias} not found in array`);
      return;
    }

    const arr = [...this.selectedAliasArr];

    arr.splice(i, 1);

    this.selectedAliasArr = arr;
    this.selected.emit(this.selectedAliasArr);
  }
}
